import { LoginCredentials } from "../models/credentials";
import { TeacherCurator } from "../models/teacher-curator";
import { fetchData } from "../utils/fetchData";

export async function getLoggedTeacherCurator(): Promise<TeacherCurator> {
    const response = await fetchData("/api/teacher-curators", { method: "GET" });
    return response.json();
}

export async function fetchTeacherCurators(): Promise<TeacherCurator[]> {
    const response = await fetchData("/api/teacher-curators/all", { method: "GET" });
    return response.json();
}

export async function getTeacherCurator(teacherCuratorId: string): Promise<TeacherCurator> {
    const response = await fetchData("/api/teacher-curators/"+teacherCuratorId, { method: "GET" });
    return response.json();
}

export interface TeacherCuratorSignUpCredentials {
    fullName: string,
    phone: string,
    email: string,
    telegram: string,
    position: string,
    login: string,
    password: string,
}

export async function signUp(credentials: TeacherCuratorSignUpCredentials): Promise<TeacherCurator> {
    const response = await fetchData("/api/teacher-curators/signup",
    {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(credentials),
    });
    return response.json();
}


export async function login(credentials: LoginCredentials): Promise<TeacherCurator> {
    const response = await fetchData("/api/teacher-curators/login",
    {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(credentials),
    });
    return response.json();
}

export async function logout() {
    await fetchData("/api/teacher-curators/logout", {method: "POST"});
}